<li #notificationLI ngbDropdown class="nav-item dropdown-notification mr-25">
    <a class="nav-link" ngbDropdownToggle id="navbarNotificationDropdown" [ngClass]="_communicationService.newNotificationNumber > 0 ? 'new-notifications' : ''">
        <div>
            <i class="ficon" data-feather="bell"></i>
        </div>
        <span class="badge badge-pill badge-primary badge-up" *ngIf="_communicationService.newNotificationNumber > 0">{{_communicationService.newNotificationNumber}}</span>
    </a>
    <ul #notificationUL *ngIf="notificationsLoaded" ngbDropdownMenu aria-labelledby="navbarNotificationDropdown" class="dropdown-menu dropdown-menu-media dropdown-menu-right">
        <!-- Notifications header -->
        <li class="dropdown-menu-header">
            <div class="dropdown-header d-flex">
                <h4 class="notification-title mb-0 mr-auto">{{"MENU.NOTIFICATIONS" | translate}}</h4>
                <div class="badge badge-pill badge-light-primary cursor-pointer" *ngIf="_communicationService.newNotificationNumber > 0" (click)="goToNotifications()">
                    {{ _communicationService.newNotificationNumber }} {{_communicationService.newNotificationNumber < 2 ? ("NEW_ONE_NOTIFICATION" | translate) : ("NEW_MANY_NOTIFICATIONS" | translate) }}
                </div>
            </div>
        </li>
        <!--/ Notifications header -->

        <!-- Notifications content -->
        <li class="scrollable-container media-list" [perfectScrollbar] *ngIf="_communicationService.myNotifications.length > 0">
            <a class="d-flex" [ngClass]="notification.read ? '' : 'new-notification'" href="javascript:void(0)" *ngFor="let notification of _communicationService.myNotifications">
                <div class="media d-flex align-items-start" (click)="openNotification(notification.id)">
                    <div class="media-body">
                        <p class="media-heading" [innerHTML]="notification.title"></p>
                        <small class="notification-text text-break-line-1 mb-0" [innerHTML]="_utilService.stripHTML(notification.text)"></small>
                    </div>
                </div>
            </a>
        </li>
        <!--/ Notifications content -->

        <li class="scrollable-container media-list" [perfectScrollbar] *ngIf="_communicationService.myNotifications.length < 1">
            <div class="font-medium-1 px-1 py-1">{{'YOU_HAVENOT_NOTIFICATION' | translate}}</div>
        </li>

        <!-- Notifications footer -->
        <li class="dropdown-menu-footer" *ngIf="_communicationService.myNotifications.length > 0">
            <a (click)="goToNotifications()" class="btn btn-primary btn-block">{{"VIEW_OTHER_NOTIFICATIONS" | translate}}</a>
        </li>
        <!--/ Notifications footer -->
    </ul>
</li>
